import React from "react";

import { Form } from "components";

export default function Filters({ data, onChange, onClean }) {
  return (
    <Form className="row form-filters">
      <Form.Field className="col-md-3">
        <Form.Label>Campanhas Ativas</Form.Label>
        <Form.Select
          placeholder="Selecionar"
          options={[
            { value: true, label: "Sim" },
            { value: false, label: "Não" },
          ]}
          value={data.status_value}
          onChange={(value) => onChange("status_value", value)}
        />
      </Form.Field>
      <Form.Field className="col-md-3">
        <Form.Label>Buscar campanha</Form.Label>
        <Form.Input
          placeholder="Campanha comercial"
          value={data.title_value.label}
          onChange={({ target }) => onChange("title_value", target)}
        />
      </Form.Field>
      <Form.Field className="col-md-3">
        <Form.Button className="button-clean-filter" onClick={onClean}>
          Resetar Filtro
        </Form.Button>
      </Form.Field>
    </Form>
  );
}
